/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const dealflowDocSectionDtoSchema = z.object({
  label: z.optional(z.string()),
  status: z.optional(z.string()),
});
